import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useRealtime } from "../contexts/RealtimeContext";
import { useData } from "../contexts/DataContext";
import { playMentionSound } from "../lib/sound";
import DeadlineToast from "./DeadlineToast";

export default function DeadlineListener() {
  const { subscribe } = useRealtime();
  const { refreshNotifications } = useData();
  const navigate = useNavigate();

  useEffect(() => subscribe((evt) => {
    if (evt.type === "notification" && (evt.ntype === "deadline" || evt.ntype === "reminder") && evt.task) {
      playMentionSound();
      refreshNotifications().catch(() => {});
      toast.custom((t) => (
        <DeadlineToast evt={evt}
          onView={() => {
            toast.dismiss(t);
            navigate(`/project/${evt.task.project_id}?task=${evt.task.id}`);
          }}
          onDismiss={() => toast.dismiss(t)} />
      ), { duration: evt.ntype === "deadline" ? 30000 : 15000 });
    }
  }), [subscribe, navigate, refreshNotifications]);

  return null;
}
